import { useEffect } from "react";
import { Link, useRouteError } from "react-router";

import { Button } from "@/shared/foundation/primitives";
import { Goto } from "@/shared/navigation";
import { ErrorMonitoringService } from "@/shared/services/ErrorMonitoringService";

import styles from "./FullPageError.module.css";

export function ErrorPage() {
  const error = useRouteError();

  useEffect(() => {
    ErrorMonitoringService.captureError(error);
  }, [error]);

  return (
    <div className={styles.container}>
      <p className={styles.heading}>Oops</p>
      <p className={styles.subheading}>Something went wrong</p>
      <p className={styles.description}>
        We apologize for the inconvenience. The team has been notified and is
        working to fix the issue.
      </p>
      <div className={styles.actions}>
        <Link to={Goto.route.Home} style={{ textDecoration: "none" }}>
          <Button variant="contained" size="large">
            Go to Homepage
          </Button>
        </Link>
      </div>
    </div>
  );
}
